<!-- main wrapper -->
<div class="main-wrapper">
  <header>
    <div class="hamburger d-inline-block d-md-none" *ngIf="!isNotAppPage" (click)="toggleMenu()" onkeypress="toggleMenu()">
      <i class="fas fa-bars" *ngIf="!menuOpen"></i>
      <i class="fas fa-times" *ngIf="menuOpen"></i>
    </div>
    <div class="logo-container">
      <img src="/assets/images/jh-logo-white.png" alt="john hancock logo" class="logo">
    </div>
    <div class="container container-header">
      <div class="row row-header">
        <div class="col col-4 col-lg-6">
          <img id="sessionIMG" width="0" height="0" src="{{sessionIMGUrl}}"  alt="session image" />
        </div>
      </div>
    </div>
  </header>
  <!-- subnav and subheader -->
  <demo-subnav-component id="demoHeader"></demo-subnav-component>
  <subheader-component *ngIf="!isNotAppPage"></subheader-component><!-- /subnav and subheader -->
  <!-- navigation and form -->
  <div class="container container-main" [ngClass]="{'center-align': isNotAppPage, 'left-align': !isNotAppPage, 'bigger-screen': isWideScreen}">
    <div [ngClass]="{'justify-content-center': hideDetails, 'hide-menu': !menuOpen}">
      <main class="col col-9 col-main" *ngIf="!validBrowser">
        <p style="font-size: 1.575rem; margin-bottom: 0.5rem; font-weight: 500; line-height: 1.2;">
            <strong>Unsupported Browser!</strong> This website will offer limited functionality in this browser.
            We only support the recent versions for major browsers like Chrome, Firefox, Safari, and Edge.
        </p>
      </main>
      <ng-container *ngIf="validBrowser">
        <router-outlet #outlet="outlet"></router-outlet>
      </ng-container>
    </div>
  </div><!-- /navigation and form -->
</div><!-- /main wrapper -->
<!-- footer -->
<footer>
  <div class="container">
    <div class="row">
      <div class="col text-muted text-center">
        <img src="/assets/images/jh-logo-white.png" alt="John Hancock logo" class="logo">
      </div>
      <div class="col-12 text-white">
        <div class="text-center">Insurance products issued by: John Hancock Life Insurance Company (U.S.A.), Boston, MA 02116.</div>
        <div class="text-center"><a href="https://www.johnhancock.com/privacysecurity.html" target="_blank">Privacy &amp; Security</a> and <a href="https://www.johnhancock.com/legal.html" target="_blank">Terms of Use</a> </div>
        <div class="text-center">Copyright &copy; {{year}} John Hancock. All rights reserved.</div>
      </div>
    </div>
  </div>
</footer><!-- /footer -->
